import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';
import { get } from 'lodash';

import DropdownValidation from 'common/DropdownValidation';

const baseString = 'vra-seed-product-selector-rm-dropdowns';
const classString = classNames({
  [`${baseString}`]: true
});
const SeedProductSelectorRm = ({
  onChangeRm,
  rmValues,
  searchParams,
  validationResult
}) => {

  const [lastChanged, setLastChanged] = useState();
  const { rmMax, rmMin } = searchParams;

  return (
    <section className={classString}>
      <DropdownValidation
        className='vra-variety-select'
        options={rmValues}
        setValue={(value) => {
          setLastChanged('rmMin');
          onChangeRm(value, 'rmMin');
        }}
        validationResult={lastChanged === 'rmMin' ? get(validationResult, 'resultsByKey.rmMin') : null}
        value={rmMin}
      />
      <span>{getMessage('to')}</span>
      <DropdownValidation
        className='vra-variety-select'
        options={rmValues}
        setValue={(value) => {
          setLastChanged('rmMax');
          onChangeRm(value, 'rmMax');
        }}
        validationResult={lastChanged === 'rmMax' ? get(validationResult, 'resultsByKey.rmMax') : null}
        value={rmMax}
      />
    </section>
  );
};
SeedProductSelectorRm.propTypes = {
  onChangeRm: PropTypes.func.isRequired,
  rmValues: PropTypes.array.isRequired,
  searchParams: PropTypes.object.isRequired,
  validationResult: PropTypes.object
};
export default SeedProductSelectorRm;
